import { render, staticRenderFns } from "./StreamingBar.vue?vue&type=template&id=2a188b08&scoped=true"
import script from "./StreamingBar.vue?vue&type=script&lang=js"
export * from "./StreamingBar.vue?vue&type=script&lang=js"
import style0 from "./StreamingBar.vue?vue&type=style&index=0&id=2a188b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a188b08",
  null
  
)

export default component.exports